/* S ACTIVE — Favourites (hearts). Saved in the shopper's browser.
   Each time a shopper adds a favourite, an "AddToWishlist" event is sent to Meta. */
(function () {
  if (window.SAFav) return;
  var KEY = 'sa_favourites';

  /* The Meta (Facebook) pixel that receives the favourites event */
  var META_PIXEL_ID = '2041358783045068';

  function read() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; }
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
  }
  function refresh() {
    var list = read();
    var ids = list.map(function (x) { return x.id; });
    document.querySelectorAll('[data-sa-fav]').forEach(function (b) {
      var on = ids.indexOf(b.getAttribute('data-sa-fav')) !== -1;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.setAttribute('aria-label', on ? 'Remove from favourites' : 'Add to favourites');
    });
    document.querySelectorAll('[data-sa-fav-count]').forEach(function (el) {
      el.textContent = list.length;
      el.hidden = list.length === 0;
    });
  }
  function toggle(item) {
    var list = read();
    var i = -1;
    list.forEach(function (x, n) { if (x.id === item.id) i = n; });
    if (i > -1) list.splice(i, 1); else list.unshift(item);
    write(list);
    refresh();
    document.dispatchEvent(new CustomEvent('sa:favourites', { detail: list }));
    return i === -1;
  }

  /* ---------- tracking ---------- */

  /* Shoppers who have declined marketing cookies are not tracked */
  function marketingAllowed() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (cp && typeof cp.marketingAllowed === 'function') return cp.marketingAllowed() !== false;
    } catch (e) {}
    return true;
  }

  var metaReady = false;
  function metaPixel() {
    if (!window.fbq) {
      (function (f, b, e, v, n, t, s) {
        n = f.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments); };
        if (!f._fbq) f._fbq = n;
        n.push = n; n.loaded = true; n.version = '2.0'; n.queue = [];
        t = b.createElement(e); t.async = true; t.src = v;
        s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s);
      })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    }
    if (!metaReady) {
      var known = false;
      try {
        known = window.fbq.getState().pixels.some(function (p) { return String(p.id) === META_PIXEL_ID; });
      } catch (e) {}
      if (!known) {
        /* no automatic extra events — only the favourites event is sent from here */
        window.fbq('set', 'autoConfig', false, META_PIXEL_ID);
        window.fbq('init', META_PIXEL_ID);
      }
      metaReady = true;
    }
    return window.fbq;
  }

  function send(data) {
    /* Shopify's own event stream (for any pixel added in Settings → Customer events) */
    try {
      if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) {
        window.Shopify.analytics.publish('sa_add_to_favourites', data);
      }
    } catch (e) {}

    if (!marketingAllowed()) return;
    try { metaPixel()('trackSingle', META_PIXEL_ID, 'AddToWishlist', data); } catch (e) {}
  }

  function track(item) {
    var data = { content_type: 'product', content_ids: [String(item.variant || '')] };
    try { data.currency = window.Shopify.currency.active; } catch (e) {}
    if (!item.handle) { send(data); return; }

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'products/' + item.handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (p) {
        var v = null;
        (p.variants || []).forEach(function (x) { if (String(x.id) === String(item.variant)) v = x; });
        data.content_name = p.title;
        if (v) {
          data.value = v.price / 100;
          data.variant = v.title;
        } else if (typeof p.price === 'number') {
          data.value = p.price / 100;
        }
        send(data);
      })
      .catch(function () { send(data); });
  }

  /* ---------- hearts ---------- */

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-sa-fav]');
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    var item = {
      id: b.getAttribute('data-sa-fav'),
      handle: b.getAttribute('data-handle'),
      variant: b.getAttribute('data-variant')
    };
    var added = toggle(item);
    if (added) {
      b.classList.remove('sa-pop'); void b.offsetWidth; b.classList.add('sa-pop');
      track(item);
    }
  }, true);

  window.SAFav = { read: read, write: write, toggle: toggle, refresh: refresh };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh);
  else refresh();

  var t;
  new MutationObserver(function () { clearTimeout(t); t = setTimeout(refresh, 120); })
    .observe(document.documentElement, { childList: true, subtree: true });
})();
